import moment from 'moment';
import {
  convertToUTC
} from "../../utils/Util";
import {
  GetCompanyDealerId,
  TargetPayApi
} from "../../utils/UtilTarget";
import { toast } from 'react-toastify';

export class DashboardDataLoader {
  public static async GetPayments(
    dateCriteria: any,
    dealerLocationsID: number,
    pageSize: Number
  ): Promise<any> {
    try {
      let obj: any = new Object();
      let objBody: any = new Object();

      obj.query = "PerseusPay.Payments";

      if (dealerLocationsID == -1) {
        objBody.CompanyDealerId = await GetCompanyDealerId();
      } else {
        objBody.DealerId = dealerLocationsID;
      }

      objBody.Search = "";
      objBody.PageNumber = 0;
      objBody.PageSize = pageSize;
      
      if (!dateCriteria || dateCriteria.length === 0 || dateCriteria[0] === '' || dateCriteria[1] === '') {
        console.error("Date criteria is invalid or missing.");
      } else {
        let startDate = moment(dateCriteria[0])
        let endDate = moment(dateCriteria[1])

        if (!startDate.isValid() || !endDate.isValid()) {
          console.error("One or both dates are invalid.");
        } else {
          endDate.set({ hour: 23, minute: 59, second: 59 });

          objBody.StartDate = startDate.utc().format();
          objBody.EndDate = endDate.utc().format();
        }
      }

      obj.queryBody = JSON.stringify(objBody);

      const response = await TargetPayApi(
        "query",
        JSON.stringify(obj),
        "post",
        "Everest"
      );
      return response;
    } catch (error) {
      alert(error);
    }
  }

  public static async GetTransactionMatrix(
    dateCriteria: any,
    dealerLocationsID: number,
    pageSize: Number
  ): Promise<any> {
    try {
      let obj: any = new Object();

      if (dealerLocationsID == -1) {
        obj.CompanyDealerID = await GetCompanyDealerId();
      } else {
        obj.DealerID = dealerLocationsID;
      }
      obj.FromDate = convertToUTC(dateCriteria[0]);
      obj.ToDate = convertToUTC(dateCriteria[1],'end');

      var resp = await TargetPayApi(`Matrix`, obj, "Get", "Dashboard");
      return resp;
    } catch (error) {
      alert(error);
    }
  }

  public static async GetDealerLocations(dealerId): Promise<any> {
    try {
      let obj: any = new Object();
      let objBody: any = new Object();

      obj.query = "PerseusPay.GetDealerLocations";
      objBody.DealerId = dealerId;

      obj.queryBody = JSON.stringify(objBody);

      const response = await TargetPayApi(
        "query",
        JSON.stringify(obj),
        "post",
        "Everest"
      );
      return response;
    } catch (error) {
      alert(error);
    }
  }

  public static async GetCardBrandUsageData(
    dateCriteria: any,
    dealerLocationsID: number
  ): Promise<any> {
    try {
      let obj: any = new Object();

      if (dealerLocationsID == -1) {
        obj.CompanyDealerID = await GetCompanyDealerId();
      } else {
        obj.DealerID = dealerLocationsID;
      }
      obj.FromDate = dateCriteria[0];
      obj.ToDate = dateCriteria[1];

      var resp = await TargetPayApi(`CardBrandUsage`, obj, "Get", "Dashboard");
      return resp;
    } catch (error) {
      alert(error);
    }
  }

  public static async GetPageSettings(): Promise<any> {
    try {
      var merchantId = localStorage.getItem('merchantId'); 
      if (merchantId) {
        var resp = await TargetPayApi(
          `GetByPage/${merchantId}/transaction`,
          undefined,
          "Get",
          "PageSettings"
        );
        return resp;
      }
      else {
        toast.error('Merchant Id not found');
      }
    } catch (error) {
      alert(error);
    }
  }
}
